import React from 'react'

import { FormValues } from 'donate/types'
import { I18nHtml, formatCents } from 'shared'
import { MatchingFundBannerProps } from './types'
import { connect } from 'formik'

export const MatchingFundBanner = connect<MatchingFundBannerProps, FormValues>(({ formik, display, config }) => {
  if (!config.showMatchingFund) return null

  const amountCents = formik.values.amount_cents
  const matchingCents = Math.min(amountCents, display.matchingFundLimitCents ?? 0)
  const limitModifier = amountCents > matchingCents ? '_with_limit' : ''
  const totalCents = amountCents + matchingCents
  const i18nParams = {
    total_amount_tag: `<span>${formatCents(totalCents)}</span>`,
    company_name: display.matchingFundCompanyName,
    donation_amount_tag: formatCents(amountCents),
    matching_amount_tag: formatCents(matchingCents),
    matching_limit_amount: formatCents(display.matchingFundLimitCents ?? 0),
  }

  const i18nKey = `donate.matching_fund_banner.${config.wording}_text${limitModifier}`

  return (
    <div className="donation-matching-fund-banner">
      <I18nHtml as="p" i18nKey={i18nKey} options={i18nParams} />
    </div>
  )
})
